export const PATIENT_GET_REQUESTED = 'PATIENT_GET_REQUESTED';
export const PATIENT_GET_SUCCEED = 'PATIENT_GET_SUCCEED';
export const PATIENT_GET_FAILED = 'PATIENT_GET_FAILED';

export const PATIENT_SEARCH_REQUESTED = 'PATIENT_SEARCH_REQUESTED';
export const PATIENT_SEARCH_SUCCEED = 'PATIENT_SEARCH_SUCCEED';
export const PATIENT_SEARCH_FAILED = 'PATIENT_SEARCH_FAILED';

export const CLINIC_PATIENT_SEARCH_REQUESTED = 'CLINIC_PATIENT_SEARCH_REQUESTED';
export const CLINIC_PATIENT_SEARCH_SUCCEED = 'CLINIC_PATIENT_SEARCH_SUCCEED';
export const CLINIC_PATIENT_SEARCH_FAILED = 'CLINIC_PATIENT_SEARCH_FAILED';

export const APPOINTMENT_PATIENT_CREATE_REQUESTED = 'APPOINTMENT_PATIENT_CREATE_REQUESTED';
export const APPOINTMENT_PATIENT_CREATE_SUCCEED = 'APPOINTMENT_PATIENT_CREATE_SUCCEED';
export const APPOINTMENT_PATIENT_CREATE_FAILED = 'APPOINTMENT_PATIENT_CREATE_FAILED';

export const PATIENT_GET_LAST_30_DAYS_MC_REQUESTED = 'PATIENT_GET_LAST_30_DAYS_MC_REQUESTED';
export const PATIENT_GET_LAST_30_DAYS_MC_SUCCEED = 'PATIENT_GET_LAST_30_DAYS_MC_SUCCEED';
export const PATIENT_GET_LAST_30_DAYS_MC_FAILED = 'PATIENT_GET_LAST_30_DAYS_MC_FAILED';

export const PATIENT_COUNT_LAST_30_DAYS_MC_REQUESTED = 'PATIENT_COUNT_LAST_30_DAYS_MC_REQUESTED';
export const PATIENT_COUNT_LAST_30_DAYS_MC_SUCCEED = 'PATIENT_COUNT_LAST_30_DAYS_MC_SUCCEED';
export const PATIENT_COUNT_LAST_30_DAYS_MC_FAILED = 'PATIENT_COUNT_LAST_30_DAYS_MC_FAILED';

export const PATIENT_COUNT_LAST_30_DAYS_MC_RESET = 'PATIENT_COUNT_LAST_30_DAYS_MC_RESET';

export const PATIENT_GET_RECENT_REASON_REQUESTED = 'PATIENT_GET_RECENT_REASON_REQUESTED';
export const PATIENT_GET_RECENT_REASON_SUCCEED = 'PATIENT_GET_RECENT_REASON_SUCCEED';
export const PATIENT_GET_RECENT_REASON_FAILED = 'PATIENT_GET_RECENT_REASON_FAILED';

export const PATIENT_GET_RECENT_REASON_RESET = 'PATIENT_GET_RECENT_REASON_RESET';
